// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.friend-links {\r\n  margin-top: 20px;\r\n  background: #fff;\r\n  border-radius: 5px;\r\n  padding: 35px;\n}\n.friend-links .title {\r\n  margin: 0px auto 20px auto;\r\n  text-align: center;\n}\n.friend-links .content img {\r\n  width: 810px;\n}\r\n", ""]);
// Exports
module.exports = exports;
